<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="对账主体" prop="merchantName">
          <jr-select
            v-model="form.merchantName"
            placeholder="请选择对账主体"
            :size="formSize"
            :options="parentMerchantOptions"
            :propsConfig="{value: 'merchantName', label: 'merchantName'}"
            value-key="merchantName"
            :hasAll="false"
            :is-bind-obj="true"
            select-style="width: 100%"
            :disabled="isModify"
            @change="selectMainChange"
          />
        </el-form-item>
        <el-form-item label="所属渠道" prop="channelType" v-if="form.merchantName">
          <jr-select
            v-model="form.channelType"
            placeholder="请选择"
            :size="formSize"
            :options="channelTypeOptions"
            :hasAll="false"
            value-key="channelType"
            :propsConfig="{value: 'channelType', label: 'label'}"
            :is-bind-obj="true"
            select-style="width: 100%"
            :disabled="isModify"
            @change="selectChannelTypeChange"
          />
        </el-form-item>
        <el-form-item label="主体编号" prop="merchantNo">
          <el-input v-model.trim="form.merchantNo" disabled :size="formSize" />
        </el-form-item>
        <el-form-item label="对账项目" prop="countingItem">
          <el-checkbox-group v-model="form.countingItem">
            <el-checkbox :label="receiptLabel" :disabled="form.merchantNo === '10086293880' && form.channelType.channelType === 3">线上收款</el-checkbox>
            <el-checkbox :label="payLabel" :disabled="form.merchantNo === '10086347290' && form.channelType.channelType === 3">代付</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" :size="formSize" style="width: 100%">
            <el-option label="启用" value="ON"></el-option>
            <el-option label="禁用" value="OFF"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间" v-if="isModify">{{form.modifyTime | formatTime}}</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize">取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="submitLoading"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { configOperation, getQueryBodyList } from '@/api/counting';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isModify: {
      type: Boolean,
      default: false,
    },
    currentObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: '',
      submitLoading: false,
      form: {
        countingItem: [],
        merchantNo: '',
        merchantName: '',
        id: '',
        modifyTime: '',
        status: 'ON',
        channelType: '',
        parentMerchantNo: '',
        channelFeeAcc: '',
      },
      rules: {
        merchantName: [{ required: true, message: '请选择', trigger: 'change' }],
        countingItem: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }],
        merchantNo: [{ required: true, message: '请选择', trigger: 'blur' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }],
        channelType: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      parentMerchantOptions: [],
      options: [
        { label: '易宝', value: 3 },
        { label: '易票联', value: 4 },
      ],
    };
  },
  computed: {
    receiptLabel() {
      return this.form.channelType.channelType === 4 ? 'yplReceiptTrade' : 'ybReceiptTrade';
    },
    payLabel() {
      return this.form.channelType.channelType === 4 ? 'yplPay' : 'ybPay';
    },
    channelTypeOptions() {
      const list = [];
      (this.parentMerchantOptions || []).forEach((it) => {
        if (it.merchantName === this.form.merchantName) {
          it.configBodyRespList.forEach((el) => {
            list.push({ label: el.channelType === 3 ? '易宝' : '易票联', ...el });
          });
        }
      });
      return list;
    },
  },
  methods: {
    getParentMerchantOptions() {
      return new Promise((resolve, reject) => {
        getQueryBodyList({ transType: 2 }).then((res) => {
          this.parentMerchantOptions = res.data || [];
          resolve(res);
        }).catch((e) => {
          this.parentMerchantOptions = [];
          reject(e);
        });
      });
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(async () => {
        this.title = `对账主体${this.isModify ? '编辑' : '新增'}`;
        await this.getParentMerchantOptions();
        const { channelType = '', id, channelFeeAcc, merchantNo, merchantName, countingItemSign, modifyTime, status, parentMerchantNo } = this.currentObj;
        this.form = {
          id: id || '',
          merchantNo: merchantNo || '',
          merchantName: merchantName || '',
          countingItem: countingItemSign ? countingItemSign.split(',') : [],
          modifyTime: modifyTime || '',
          status: status || 'ON',
          parentMerchantNo: parentMerchantNo || '',
          channelType: {
            channelType,
          },
          channelFeeAcc,
        };
        this.$refs.form.resetFields();
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const params = {
              ...this.form,
              countingItem: this.form.countingItem.join(','),
              transType: 2, // 类型 1-自营 2-服务商
              channelType: this.form.channelType.channelType,
            };
            delete params.modifyTime;
            this.submitLoading = true;
            await configOperation(params);
            this.$message.success(`${this.isModify ? '编辑' : '新增'}成功！！`);
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
    selectMainChange(val) {
      this.form.merchantName = val.merchantName || '';
      this.form.channelType = {};
      this.form.parentMerchantNo = '';
      this.form.merchantNo = '';
      // 服务商文火火情况需要特别判断，因为特殊服务商文火火，易宝数据(7290)和财务数据(8649)用的账户不一致，代付都用3880
      if (['10086293880', '10086347290'].includes(val.merchantNo) && this.form.countingItem.length && this.form.channelType.channelType === 3) {
        this.form.countingItem = [];
      }
    },
    selectChannelTypeChange(val) {
      this.form.countingItem = [];
      this.form.parentMerchantNo = val.parentMerchantNo || '';
      this.form.merchantNo = val.merchantNo || '';
      this.form.channelFeeAcc = val.channelFeeAcc || '';
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .content {
    margin-right: 0;
  }
}
</style>
